import { Grid, Paper } from "@material-ui/core";
import ActivitiesWidget from "./ActivitiesWidget/ActivitiesWidget";
import AssetListWidget from "./AssetListWidget/AssetListWidget";
import AssetLocationWidget from "./AssetLocationWidget/AssetLocationWidget";
import { fleetManagementDashboardStyle } from "./style";
import TotalAssetsWidget from "./TotalAssetsWidget/TotalAssetsWidget";
import WorkorderApprovalWidget from "./WorkorderApprovalWidget/WorkorderApprovalWidget";
import { useTitle } from "hooks/useTitle";
import { useDispatch, useSelector } from "react-redux";
import { selectUserClientId, userHasOneClient,selectIsLoggedIn } from "features/user/userSlice";
import DropdownFilter from "components/DropdownFilter";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { setFilters } from "./fleetManagementDashboardSlice";
import { readinessTypes } from "features/vehicles/components/AssetReadiness/readinessUtil";
import { useGetClientsWithConfigsQuery } from "features/clients/clientConfigSlice";
import DwellWidget from "./DwellWidget/DwellWidget";

const FleetManagementDashboard = () => {
    const classes = fleetManagementDashboardStyle();

    let userClientId = useSelector(selectUserClientId);

    const isUserLoaded = useSelector(selectIsLoggedIn);

    let { data: clients, error: clientsError, isLoading: isLoadingClients } = useGetClientsQuery();

    const clientAccounts = clients?.flatMap(c => c.clientAccounts);
    const clientAccountLookup = clientAccounts?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});

    let {
        data: clientsWithConfigs,
        error: clientsWithConfigsError,
        isFetching: isLoadingClientsWithConfigs
    } = useGetClientsWithConfigsQuery(null, { skip: !isUserLoaded });
    clientsWithConfigs = clientsWithConfigs || [];

    const hasOneClaim = useSelector(userHasOneClient);
    const { dashboardFilters } = useSelector(state => state.fleetManagementDashboardState);
    const dispatch = useDispatch();

    useTitle('Fleet Management Dashboard');

    const showReadiness = clientsWithConfigs?.some(c => c?.config?.readinessConfig?.readinessType != readinessTypes.OFF && c?.config?.readinessConfig?.readinessType != null)

    const handleFilterChange = (key, value) => {
        const newFiletrs = { ...dashboardFilters, [key]: value };
        if (key == 'clientAccountId') {
            newFiletrs['clientId'] = clientAccountLookup?.[value]?.clientId;
            newFiletrs['isDefaultAccount'] = clientAccountLookup?.[value]?.isDefault;
        }
        dispatch(setFilters(newFiletrs));
    }

    return <Grid container spacing={2}>
        {!hasOneClaim && <Grid item xs={12} className={classes.filterItem}>
            <DropdownFilter
                values={[{ id: '', name: 'All clients' }, ...(clientAccounts ?? [])]}
                onSelect={(val) => handleFilterChange('clientAccountId', val)}
                value={dashboardFilters?.['clientAccountId']}
            />
        </Grid>}
        <Grid item xs={12} md={showReadiness ? 4 : 6}>
            <Paper className={classes.widgetWrapper}>
                <WorkorderApprovalWidget />
            </Paper>
        </Grid>
        {showReadiness &&
            <Grid item xs={12} md={4}>
                <Paper className={classes.widgetWrapper}>
                    <TotalAssetsWidget />
                </Paper>
            </Grid>
        }
        <Grid item xs={12} md={showReadiness ? 4 : 6}>
            <Paper className={classes.widgetWrapper}>
                <AssetListWidget />
            </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
            <Paper className={classes.widgetWrapperBig}>
                <ActivitiesWidget tooltipInfo={`The top 10 Activities performed for your fleet over the selected time frame. 
                        You can toggle to Pricing to see the top 10 activities performed for your fleet by cost.`} />
            </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
            <Paper className={classes.widgetWrapperBig}>
                <AssetLocationWidget />
            </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
            <Paper className={classes.widgetWrapperBig}>
                <DwellWidget />
            </Paper>
        </Grid>
    </Grid>
}
export default FleetManagementDashboard;